import { Button, Callout, useOverlayContext } from 'seagull';
import { SyncLiner24 } from 'seagull/icons';
import { useStore, useStoreActions } from "../../../contexts";
import { handleRequest } from "../../../infra/utils";
import { getPMDetails } from "../pm.utils";
import { relationshipModel } from "../../../models";
import { selectors } from "../../../store/state-selectors";
import PMSyncCompaniesModal from "../PMSyncCompaniesModal/PMSyncCompaniesModal";
import styles from "./PracticeManagementSyncFailures.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function PracticeManagementSyncFailures(_ref) {
  let {
    relationship,
    refresh
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    children: relationshipModel.practiceManagementSyncFailures(relationship).map(failure => /*#__PURE__*/_jsx("div", {
      className: styles.pmSyncFailureContainer,
      children: /*#__PURE__*/_jsx(PracticeManagementFailureCallout, {
        failure: failure,
        relationship: relationship,
        refresh: refresh
      })
    }, failure.getType()))
  });
}
function PracticeManagementFailureCallout(_ref2) {
  let {
    failure,
    relationship,
    refresh
  } = _ref2;
  const pmType = failure.practiceManagementType();
  const pmDetails = pmType && getPMDetails(pmType);
  const overlayContext = useOverlayContext();
  const {
    api
  } = useStoreActions();
  const showKeeperIntegration = useStore(selectors.integration.showKeeperIntegration);
  const showKarbonIntegration = useStore(selectors.integration.showKarbonIntegration);
  const showClientHubIntegration = useStore(selectors.integration.showClientHubIntegration);
  const showFinancialCentsIntegration = useStore(selectors.integration.showFinancialCentsIntegration);
  const shouldShowFailure = () => {
    return failure.accept({
      visitKeeper: () => showKeeperIntegration,
      visitKarbon: () => showKarbonIntegration,
      visitClientHub: () => showClientHubIntegration,
      visitFinancialCents: () => showFinancialCentsIntegration
    });
  };
  if (!pmDetails || !shouldShowFailure()) return null;
  const openPMSyncContactsModal = () => {
    overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref3 => {
        let {
          dismissModal
        } = _ref3;
        return /*#__PURE__*/_jsx(PMSyncCompaniesModal, {
          dismissModal: dismissModal,
          practiceManagementType: pmType,
          relationship: relationship,
          getMatchingCompanies: () => api.practiceManagement.getMatchingCompanies(pmType, relationshipModel.id(relationship)),
          getLinkCompany: companyId => api.practiceManagement.linkContact(pmType, relationshipModel.id(relationship), companyId),
          createNewCompanyAndContact: relationshipId => api.practiceManagement.createNewCompanyAndContact(pmType, relationshipId),
          refresh: refresh
        });
      }
    });
  };
  const handleDismissSyncFailure = async () => {
    overlayContext.startLoader();
    const result = await handleRequest(api.practiceManagement.dismissSyncFailure(pmType, relationshipModel.id(relationship)));
    if (!result.success) {
      overlayContext.showErrorToast('Failed to dismiss', 'pm-sync-failure-dismiss-btn-error-toast');
      return;
    }
    await refresh({
      silent: true
    });
    overlayContext.stopLoader();
  };
  return /*#__PURE__*/_jsx(Callout, {
    intent: "error",
    withBorder: true,
    icon: /*#__PURE__*/_jsx(SyncLiner24, {
      width: 18,
      height: 18
    }),
    testId: "pm-sync-failure-".concat(pmType),
    withAction: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Button, {
        skin: "primary",
        onClick: () => openPMSyncContactsModal(),
        testId: "pm-sync-failure-btn-".concat(pmType),
        children: ["Select ", pmDetails.company]
      }), /*#__PURE__*/_jsx(Button, {
        skin: "primaryOutline",
        onClick: () => handleDismissSyncFailure(),
        testId: "pm-dismiss-sync-failure-btn-".concat(pmType),
        children: "Dismiss"
      })]
    }),
    children: "There are multiple ".concat(pmDetails.company, " names in ").concat(pmDetails.name, " linked to the contact. To automatically\n            generate ").concat(pmDetails.items, " in ").concat(pmDetails.name, " based on the services in this agreement, please select the\n            correct ").concat(pmDetails.company, ".")
  });
}